<template>
<div id="app">
  <Search-scheme />
  <widget-container-modal />
</div>
</template>

<script>
import SearchScheme from "./components/SearchScheme.vue"
import {container} from "jenesius-vue-modal";
export default{
  name: "app",
  components:{
    SearchScheme,
    WidgetContainerModal: container,
  },
   

};
</script>

<style>

</style>
